import { Injectable } from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { Enum } from '@shared/enum/enum';
import { DatetimeUtil } from '@shared/util/datetime.util';

import { BeneficiaryGroup } from './beneficiary-group';
import {
  BeneficiaryGroupStatus,
  beneficiaryGroupStatusGetRoleForStatusUpdate,
  beneficiaryGroupStatusNextStatus,
} from './beneficiary-group-status.enum';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryGroupHelper {
  constructor(private sessionService: SessionService) {}

  static hasStarted(beneficiaryGroup: BeneficiaryGroup): boolean {
    return (
      beneficiaryGroup.status?.code === BeneficiaryGroupStatus.IN_PROGRAM ||
      beneficiaryGroup.status?.code === BeneficiaryGroupStatus.OUT_OF_PROGRAM
    );
  }

  static calculateExpectedEndDate(beneficiaryGroup: BeneficiaryGroup): Date {
    if (beneficiaryGroup.endDate) {
      return beneficiaryGroup.endDate;
    }

    if (!beneficiaryGroup.startDate) {
      return new Date();
    }

    const endDate = new Date(beneficiaryGroup.startDate);
    endDate.setDate(endDate.getDate() + (beneficiaryGroup.maxRunningTime || 100) * 7);

    return endDate;
  }

  static getWeeksRunning(beneficiaryGroup: BeneficiaryGroup): number {
    if (!this.hasStarted(beneficiaryGroup)) {
      return 0;
    }
    const startDate = beneficiaryGroup.startDate ? new Date(beneficiaryGroup.startDate) : new Date();
    const endDate = beneficiaryGroup.endDate ? new Date(beneficiaryGroup.endDate) : new Date();
    const till = beneficiaryGroup.status?.code === BeneficiaryGroupStatus.OUT_OF_PROGRAM ? endDate : new Date();

    return DatetimeUtil.calculateWeeksBetweenDates(startDate, till) || 0;
  }

  getNextBeneficiaryGroupStatus(currentStatus: Enum): BeneficiaryGroupStatus | null {
    const nextStatusTemp = beneficiaryGroupStatusNextStatus(currentStatus.code);
    const roleForStatusUpdate = beneficiaryGroupStatusGetRoleForStatusUpdate(nextStatusTemp);
    if (roleForStatusUpdate && this.sessionService.hasRole(roleForStatusUpdate)) {
      return nextStatusTemp;
    } else {
      return null;
    }
  }
}
